/** Склейка классов: cx('a', cond && 'b', undefined) → 'a b'. */
export function cx(...values: Array<string | false | null | undefined | 0>): string {
  let result = '';
  for (const value of values) {
    if (value) result = result ? `${result} ${value}` : value;
  }
  return result;
}
